// extracted by mini-css-extract-plugin
module.exports = {"brandname":"WebexMeeting_brandname__1r4fQ"};